import { useState, useEffect } from 'react';
import { ITree, useAsyncEffect } from '@smart/design';
import LocationTagModel from '../models/LocationTagModel';
export default function useLocationTag(companyId: string) {
  const [tags, setTags] = useState<ITree>(null);

  useAsyncEffect(function*(onCancel, c) {
    const tree = yield* c(LocationTagModel.load(companyId));
    setTags(tree);
  }, []);

  return tags;
}
